import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { EditorialStat } from '../../types/editorial-stat.type';

interface ShareholdingStatsProps {
  stats: EditorialStat[];
  note: string;
  illustration: string;
  illustrationAlt: string;
}

// Les quatre colonnes partagent une même hauteur d'en-tête : le pourcentage pour trois d'entre
// elles, l'illustration pour la quatrième. C'est ce qui aligne les descriptions entre elles.
const HEADER_HEIGHT = 'clamp(2.5rem, 8vw, 3.5rem)';

const useStyles = makeStyles({
  column: {
    textAlign: 'center',
  },
  header: {
    height: HEADER_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  value: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: HEADER_HEIGHT,
    lineHeight: 1,
    // Les pourcentages se lisent en rangée : des chiffres à chasse fixe les alignent.
    fontVariantNumeric: 'tabular-nums',
  },
  illustration: {
    height: '100%',
    width: 'auto',
    objectFit: 'contain',
    // Le camembert est vert, donc invisible sur le fond vert plein de la bande : `brightness(0)`
    // écrase la couleur vers le noir en gardant la transparence, `invert(1)` le retourne en blanc.
    filter: 'brightness(0) invert(1)',
  },
  description: {
    marginTop: '0.75rem',
    fontSize: '0.9rem',
    lineHeight: 1.5,
    opacity: 0.92,
  },
});

const ShareholdingStats: React.FC<ShareholdingStatsProps> = ({ stats, note, illustration, illustrationAlt }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={3}>
      {stats.map((stat) => (
        <Grid item xs={12} sm={6} md={3} key={stat.value} className={classes.column}>
          <div className={classes.header}>
            <Typography className={classes.value}>{stat.value}</Typography>
          </div>
          <Typography className={classes.description}>{stat.description}</Typography>
        </Grid>
      ))}

      <Grid item xs={12} sm={6} md={3} className={classes.column}>
        <div className={classes.header}>
          <img className={classes.illustration} src={illustration} alt={illustrationAlt} />
        </div>
        <Typography className={classes.description}>{note}</Typography>
      </Grid>
    </Grid>
  );
};

export default ShareholdingStats;
